module.exports = {"540325100":"烟多镇","540325101":"香堆镇","540325102":"吉塘镇","540325200":"宗沙乡","540325201":"卡贡乡","540325202":"荣周乡","540325203":"巴日乡","540325204":"阿孜乡","540325205":"王卡乡","540325206":"新卡乡","540325207":"肯通乡","540325208":"扩达乡","540325209":"察拉乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540325.json
// module id = 2710
// module chunks = 0